import React from 'react';
import IconV2 from '../v2/IconV2';
import FloatingSelectV2 from '../v2/FloatingSelectV2';
import Spinner from '../Spinner';
import { FiSettings } from '@/components/react-icons/main';

// headerList: string[]

// tableData: {
//   rows: {
//     rowData: {
//       label: string;
//       value: any;
//       clickAction: () => {};
//     }[];
//     rowId: string;
//   }[];
// }[];

const Table = ({ headerList, tableData, children, showTableActionArea = false, isLoading = false }) => {
  const handleCellClick = (cellData) => {
    cellData.clickAction();
  };

  return (
    <div id="table-component-container">
      {showTableActionArea && (
        <div className="table-action-area">
          <div className="left-section" />
          <div className="right-section">
            <IconV2 icon={FiSettings} className={'table-action-options-trigger'} />
            <FloatingSelectV2 triggers={['.table-action-options-trigger']} useSearch={false} />
          </div>
        </div>
      )}

      <div id="table-wrapper">
        <table id="base-table" className="table">
          {isLoading && (
            <div className={'table-loading'}>
              <IconV2 icon={Spinner} />
            </div>
          )}

          {!isLoading && !!children && children}

          {!isLoading && !children && headerList && (
            <thead className="table-head">
              <tr className="row">
                {headerList?.map((header, headerIndex) => (
                  <th key={headerIndex} className="head-cell">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
          )}

          {!isLoading && !children && tableData && (
            <tbody className="table-body">
              {tableData.map((row, rowIndex) => (
                <tr className="table-row" key={rowIndex}>
                  {row.rowData.map((cellData, cellIndex) => (
                    <td className={`table-cell ${cellData.clickAction ? 'clickable' : ''}`} onClick={() => handleCellClick(cellData)} key={cellIndex}>
                      {cellData.label}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};

export default Table;
